import { render, staticRenderFns } from "./calculator-table.vue?vue&type=template&id=39bc9faa&scoped=true"
import script from "./calculator-table.vue?vue&type=script&lang=js"
export * from "./calculator-table.vue?vue&type=script&lang=js"
import style0 from "./calculator-table.vue?vue&type=style&index=0&id=39bc9faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc9faa",
  null
  
)

export default component.exports